function translate(message: string): string | undefined {
  return (SB_CONFIG?.user?.translations ?? SB_CONFIG?.translations)?.[message];
}

export function _t(message: string): string {
  const translated = translate(message);
  if (!translated && process.env.NODE_ENV !== 'production') {
    // in debug, if we encounter an unknown string, throw a fatal error
    // normally, this means someone has added a new React string and has forgotten to update U_ReactStrings.pas in Delphi
    const loaded = !!SB_CONFIG?.translations;
    const errorMessage = loaded
      ? `"${message}" has no translations - please update U_ReactStrings.pas.`
      : `Attempting to translate "${message}" before loading translations.`;
    console.error(
      errorMessage,
      SB_CONFIG.translations,
      SB_CONFIG?.user?.translations,
    );
    throw errorMessage;
  }

  // in production, silently default to original english string
  return translated ?? message;
}

// Will translate, but will silently return a message rather than erroring if not found.
// Should only be used for messages which can be displayed before the first
//    request (to fetch translations) succeeds
export function _safe_t(message: string): string {
  return translate(message) ?? message;
}

export function _replaceTokens(message: string, tokens: any[]): string {
  let result = _t(message);
  for (let i = 0; i < tokens.length; i++) {
    result = result.replaceAll(`%${i + 1}%`, '' + (tokens[i] ?? ''));
  }
  return result;
}
